import { render, staticRenderFns } from "./OptinTab.vue?vue&type=template&id=ab7d570a"
import script from "./OptinTab.vue?vue&type=script&lang=js"
export * from "./OptinTab.vue?vue&type=script&lang=js"
import style0 from "./OptinTab.vue?vue&type=style&index=0&id=ab7d570a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports